export default __webpack_public_path__ + "static/media/contact-main.7b695c23.jpg";